import { memo } from 'react';
import BrandKitMediaCard from './BrandKitMediaCard';
import MediaEmptyState from './MediaEmptyState';
import BrandKitSelector from '@/Pages/BrandKit/components/BrandKitSelector/BrandKitSelector';
import { BrandKitMediaSectionProps } from '@/Pages/BrandKit/types';

function BrandKitMediaSection({
  brandKits,
  activeBrandKitId,
  onBrandKitChange,
  images,
  selectedUrl,
  onSelect,
  imageEmptyState,
  selectorAddon
}: BrandKitMediaSectionProps): JSX.Element {
  if (!brandKits.length) {
    return (
      <MediaEmptyState
        icon="IconPalette"
        title="No brand kit available"
        description="Create a brand kit to apply your brand's colors, fonts, assets, voice etc to your edited content."
        ctaLabel="Add Brand Kit"
        ctaHref="/brand-kit"
      />
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <div className={selectorAddon ? 'flex items-center gap-3' : undefined}>
        <div className="w-[213px]">
          <BrandKitSelector selectedBrandKitId={activeBrandKitId} onBrandKitChange={onBrandKitChange} />
        </div>
        {selectorAddon}
      </div>

      {!images.length ? (
        imageEmptyState
      ) : (
        <div data-testid="brandkit-images-grid" className="grid grid-cols-3 gap-4">
          {images.map(item => (
            <BrandKitMediaCard
              key={item.url}
              url={item.url}
              label={item.originalName}
              isSelected={selectedUrl === item.url}
              onClick={() => onSelect(item)}
              type="image"
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default memo(BrandKitMediaSection);
